import * as React from "react";

import { Theme } from "@components/theme/Theme";

import * as ListItem from "../ListItem";
import styles from "../styles.module.css";

function WithImageOnLeftAndRedTimestamp(props: ListItem.Props) {
  const { description, timestamp, image } = props;

  return (
    <article className={styles.listItemContainer}>
      <div className={styles.leftColumn} data-skeleton-selector>
        {image && <ListItem.Image {...props} />}
        {!image && timestamp && (
          <Theme accentColor="red">
            <ListItem.Timestamp {...props} />
          </Theme>
        )}
      </div>
      <div className={styles.mainColumn} data-skeleton-selector>
        <ListItem.Text {...props} />
        {description && <ListItem.Description {...props} />}
      </div>
    </article>
  );
}

export { WithImageOnLeftAndRedTimestamp };
